import * as React from "react";

const TrashIcon: React.FC = () => {
    return (
        <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.0108 4.58423C12.6727 4.58423 12.3743 4.84698 12.3743 5.18534V14.8428C12.3743 15.3125 11.9562 15.7074 11.4588 15.7074L3.68039 15.7081C3.18303 15.7081 2.76492 15.3132 2.76492 14.8435V5.16691C2.76492 4.84764 2.48671 4.5658 2.12845 4.5658C1.79039 4.5658 1.49197 4.82855 1.49197 5.16691V14.8243C1.49197 15.9517 2.4665 16.872 3.6601 16.872H11.4393C12.633 16.872 13.6075 15.9516 13.6075 14.8243V5.16691C13.6277 4.84764 13.3495 4.58413 13.0106 4.58413L13.0108 4.58423Z"
                fill="#AC1E2D"
            />
            <path
                d="M8.15687 13.8476V6.14396C8.15687 5.82469 7.89807 5.54285 7.56002 5.54285C7.22197 5.54285 6.96318 5.8056 6.96318 6.14396V13.8476C6.96318 14.1669 7.22197 14.4488 7.56002 14.4488C7.89807 14.4488 8.15687 14.186 8.15687 13.8476Z"
                fill="#AC1E2D"
            />
            <path
                d="M5.57055 13.8476V6.14396C5.57055 5.82469 5.31176 5.54285 4.97371 5.54285C4.63566 5.54285 4.37687 5.8056 4.37687 6.14396V13.8476C4.37687 14.1669 4.63566 14.4488 4.97371 14.4488C5.31176 14.4488 5.57055 14.186 5.57055 13.8476Z"
                fill="#AC1E2D"
            />
            <path
                d="M10.7432 13.8476V6.14396C10.7432 5.82469 10.4844 5.54285 10.1463 5.54285C9.80829 5.54285 9.5495 5.8056 9.5495 6.14396V13.8476C9.5495 14.1669 9.80829 14.4488 10.1463 14.4488C10.4844 14.4488 10.7432 14.186 10.7432 13.8476Z"
                fill="#AC1E2D"
            />
            <path
                d="M14.3638 2.25476H0.756223C0.418172 2.25476 0.119751 2.49917 0.119751 2.81844C0.119751 3.13772 0.397959 3.38213 0.756223 3.38213H14.3445C14.6826 3.38213 14.981 3.13772 14.981 2.81844C14.981 2.49917 14.702 2.25476 14.3639 2.25476H14.3638Z"
                fill="#AC1E2D"
            />
            <path
                d="M5.7492 1.12737H9.36985C9.7079 1.12737 10.0063 0.882955 10.0063 0.563684C10.0063 0.244413 9.72811 0 9.36985 0H5.7492C5.41115 0 5.11273 0.244413 5.11273 0.563684C5.11273 0.882955 5.39172 1.12737 5.7492 1.12737Z"
                fill="#AC1E2D"
            />
        </svg>
    );
};

export default React.memo(TrashIcon);
